import React, { useState, useEffect } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";

import {
  taskActions,
  userActions,
  ordersActions,
  resourcesActions,
  facilityActions,
  useSelector,
} from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils"; // necessary to communicate with inbooma-react
import DatePicker from "react-datepicker";
import InboomaTimePicker from "../../../components/InboomaTimePicker";
import { ceilToSelectable } from "../../../components/InboomaTimePicker";
import { moment, _ } from "../../../../../vendor";
import de from "date-fns/locale/de"; // @todo Make dynamic
import { getContentModifications } from "../../../../App";
import CommentList from "./CommentList";
import Notification from "./Notification";
import DescriptionAndImages from "./TaskItemComponents/DescriptionAndImages";
import FkModelInput from "./TaskItemComponents/FkModelInput";
import { resetTask } from "inbooma-api/store/tasks/actions";

const ItemView = (props) => {
  const [task, setTask] = useState(
    typeof props.task.id === "undefined"
      ? {
          // make a local copy of task or initialize a new task
          name: "Neue Aufgabe",
          task_category: "todo", // API accepts 'todo' and 'contract' (see backend modul 'tasks')
          status: "new",
          fk_model: typeof props.fk_model !== "undefined" ? props.fk_model : "",
          fk_id: typeof props.fk_id !== "undefined" ? props.fk_id : "",
          fk_description: "", // storing object descrition like order-number, resource name or user name
          assignee: "",
          team_lead: typeof props.lead !== "undefined" ? props.lead === "true" : false,
          begin: ceilToSelectable(moment()).format("YYYY-MM-DD HH:mm"),
          end: "",
          payment_amount: "",
          description: "",
          task_comments: [],
        }
      : props.task,
  );

  const _task = useSelector((state) => state.tasks.task); // used for after save process
  const _tasks = useSelector((state) => state.tasks.tasks);
  const _orders = useSelector((state) => state.orders);
  const _user = useSelector((state) => state.users_data.user); // last selected / requested user (linked or assigned)
  const _usersResults = useSelector((state) => state.users_data.users); // results of user query
  const _resourcesResults = useSelector((state) => state.resources_data.getResources);
  const [orderPending, setOrderPending] = useState(null);
  const [assignedUser, setAssignedUser] = useState(undefined); // holds the assigned user object (needs to be initialized)
  const [linkedUser, setLinkedUser] = useState(undefined);
  const [unsafedComment, setUnsafedComment] = useState(null);
  const [initialized, setInitialized] = useState(false);

  const [resource, setResource] = useState(undefined);

  const [order, setOrder] = useState({}); // there can only be one order per task
  const [orderStatus, setOrderStatus] = useState({
    request: "init",
    number: "",
  });
  const [warning, setWarning] = useState("");
  let language = Biscuit.get("user.lang").replace("-", "_");
  let splitObject = {};
  const [employeeList, setEmployeeList] = useState({});

  const [itemState, setItemState] = useState("init");
  const [notification, setNotification] = useState({
    message: "",
    show: false,
  });

  const _getUserNameById = (id) => {
    var name = props.getUserNameById(
      id,
      false,
      props.userQueue,
      props.setUserQueue,
      props.extraUsers,
    );

    if (name === "-" && props.userReady() === true) {
      name = props.getUserNameById(id, true, props.userQueue, props.setUserQueue, props.extraUsers); // not (yet) in task list - assigned and linked user are always fetched by task list
    }

    return name;
  };
  let descriptionHtml = "";
  const _initialize = () => {
    if (orderPending || initialized) return;
    // check if assigned user set
    if (assignedUser === undefined && task.assignee !== "") {
      for (var i = 0; i < props.tasks.length; i++) {
        if (props.tasks[i].id === task.id) {
          setAssignedUser(props.tasks[i].user);
          break;
        }
      }
    }

    // check if linked user set
    if (task.fk_model === "Users" && linkedUser === undefined && task.fk_id !== "") {
      setLinkedUser(task.fk_id);
    }

    // check if linked resource set
    if (task.fk_model === "Resources" && resource === undefined && task.fk_id !== "") {
      setResource(task.fk_id);
    }

    // check if order assigned
    if (
      task.fk_model === "Orders" &&
      task.fk_id !== undefined &&
      task.fk_id !== null &&
      task.fk_id !== ""
    ) {
      props.dispatch(
        ordersActions.getOrder({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            find: "IsEmployee",
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
          id: task.fk_id,
        }),
      );
      setOrderPending(true);
    }

    let split =
      typeof task.description === "undefined" || task.description == null
        ? []
        : task.description.split(" [");

    if (typeof split[1] !== "undefined") {
      let splitString = "[" + split[1];
      splitObject = JSON.parse(splitString);
      descriptionHtml = "true";
    }
  };

  useEffect(() => {
    if (_tasks.success === "") {
      // true or false no matter if a new task is created or an existing task modified
      return;
    }

    if (itemState !== "saving") return;

    var isNewTask = document.location.href.indexOf("add") >= 0;

    if (_task.success === true) {
      // show message "saved successful"
      props.showNotification("success", _task.data.id);
    }

    if (_task.success === false) {
      // show message "error during save"
      props.showNotification("warning", _task.data.id);
    }

    if (_tasks.success === true && isNewTask) {
      props.showNotification("success", _tasks.data[_tasks.data.length - 1].id);
    }

    if (_tasks.success === false && isNewTask) {
      props.showNotification("warning", 0);
    }
    // close window
    props.dispatch(taskActions.resetTask());
    abortButtonRef.current.click();
  }, [_tasks]);

  useEffect(() => {
    if (_orders.order.success === true && _orders.order.data !== undefined) {
      setOrder({ ..._orders.order.data });
      setOrderStatus({ request: "fetched", number: _orders.order.data.order_nbr });
      setTask({
        ...task,
        fk_id: _orders.order.data.id,
        fk_description: _orders.order.data.order_nbr,
      });
      setWarning("");
    }

    if (_orders.orders.success === true) {
      if (_orders.orders.data !== undefined && _orders.orders.data.length > 0) {
        setOrder({ ..._orders.orders.data[0] });
        setOrderStatus({ request: "fetched", number: _orders.orders.data[0].order_nbr });
        setTask({
          ...task,
          fk_id: _orders.orders.data[0].id,
          fk_description: _orders.orders.data[0].order_nbr,
        });
        setWarning("");
      } else {
        setWarning(t("no_order_found", null, "capital"));
        setTask({ ...task, fk_id: null });
      }
    }

    if (_orders.orders.success === false || _orders.order.success === false) {
      setWarning(t("no_order_found", null, "capital"));
      setTask({ ...task, fk_id: null });
    }
    setOrderPending(false);
    setInitialized(true);
  }, [_orders]);

  if (!initialized) _initialize();

  // ******************************************************************** assignee select **********************************************************************

  const [assigneeState, setAssigneeState] = useState({
    isOpen: false,
    value:
      assignedUser === undefined || assignedUser == null
        ? ""
        : assignedUser.first_name + " " + assignedUser.last_name,
  });

  const assigneeSelectHandle = (user) => {
    let clone = {
      ...task,
      assignee: user == null ? null : user.id,
      status: task.status === "new" ? "inprogress" : task.status,
    };

    setTask(clone);

    setAssignedUser(user);
    setAssigneeState({
      ...assigneeState,
      value: user == null ? "" : user.first_name + " " + user.last_name,
    });
  };

  // user dispatch for employees
  const queryAssigneeSelectHandle = (e) => {
    const val = e.target.value;

    // query for employees searching in first_name and last_name
    if (val.length > 0) {
      setAssigneeState({
        isOpen: true,
        value: val,
      });

      props.dispatch(
        userActions.getUsers({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true, // this is important to avoid loading all users data, only attributes for user selection are necessary
            find: "IsEmployee",
            n: e.target.value,
            q: val,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    } else {
      setAssigneeState({
        isOpen: false,
        value: val,
      });
    }
  };

  // ****************************************************************************** object type user select *************************************************************

  const [userObjectState, setUserObjectState] = useState({
    isOpen: false,
    value:
      linkedUser === null || linkedUser === undefined
        ? ""
        : props.getUserNameById(
            linkedUser,
            false,
            props.userQueue,
            props.setUserQueue,
            props.extraUsers,
          ),
  });

  const userObjectSelectHandle = (user) => {
    let name = "";
    if (user != null && typeof user.first_name !== "undefined") name += user.first_name;
    if (user != null && typeof user.last_name !== "undefined") {
      if (name.length > 0) name += " ";
      name += user.last_name;
    }

    let clone = {
      ...task,
      fk_id: user == null ? null : user.id,
      fk_description: name,
    };

    setTask(clone);

    setLinkedUser(user == null ? null : user.id);
    setUserObjectState({ ...userObjectState, value: user == null ? "" : props.getUserLabel(user) });
  };

  const queryUserObjectSelectHandle = (e) => {
    const val = e.target.value;

    // query for user using parameter 'n' for searching only in name fields
    if (val.length > 0) {
      setUserObjectState({
        value: val,
        isOpen: true,
      });

      props.dispatch(
        userActions.getUsers({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true, // this is important to avoid loading all users data, only attributes for user selection are necessary
            role: "user",
            n: val,
          },
        }),
      );
    } else {
      setUserObjectState({
        value: val,
        isOpen: false,
      });
    }
  };

  // ****************************************************************************** object type resource select *************************************************************

  const [resourceObjectState, setResourceObjectState] = useState({
    isOpen: false,
    value: resource === null || resource === undefined ? "" : resource,
  });

  const resourceObjectSelectHandle = (resource) => {
    let clone = {
      ...task,
      fk_id: resource == null ? null : resource.id,
      fk_description:
        resource == null
          ? ""
          : typeof resource.name !== "undefined" && resource.name != null
            ? resource.name
            : "",
    };

    setTask(clone);

    setResource(resource == null ? null : resource.id);
    setUserObjectState({ ...resourceObjectState, value: resource == null ? "" : resource.id });
  };

  const queryResourceObjectSelectHandle = (e) => {
    const val = e.target.value;

    if (val.length > 0) {
      setResourceObjectState({
        value: val,
        isOpen: true,
      });

      props.dispatch(
        resourcesActions.getResources({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true, // this is not implemented and ignored by backend for now but could be useful in future
            q: val,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    } else {
      setResourceObjectState({
        value: val,
        isOpen: false,
      });
    }
  };

  // ********************************************************************************************************************************************************************************

  // initialize timespan values
  const [timespan, setTimespan] = useState({
    begin_date:
      task.begin !== "" && task.begin != null
        ? new Date(moment(task.begin).format("YYYY-MM-DD"))
        : new Date(moment(task.created)),
    begin_time:
      task.begin !== "" && task.begin != null
        ? ceilToSelectable(moment(task.begin)).format("HH:mm")
        : ceilToSelectable(moment(task.created)).format("HH:mm"),
    end_date:
      task.end !== "" && task.end != null ? new Date(moment(task.end).format("YYYY-MM-DD")) : "",
    end_time:
      task.end !== "" && task.end != null ? ceilToSelectable(moment(task.end)).format("HH:mm") : "",
  });

  // returns an accumulated string in format 'YYYY-MM-DD HH:mm'
  const _getFormattedTime = (date, time) => {
    if (typeof date === "undefined" || date == null || date === "") return "";

    var total = moment(new Date(date)).format("YYYY-MM-DD");
    if (typeof time !== "undefined" && time != null && time !== "") {
      total += " " + time;
    }

    return total;
  };

  const _getSelectedObjectId = (fk_model) => {
    switch (fk_model) {
      case "Users":
        return linkedUser;
      case "Resources":
        return resource;
      case "Orders":
        return task.fk_id;
      case "Facilities":
        return task.fk_id;
    }
  };

  // evaluate form and send task to api
  const onSubmit = () => {
    // set format of date
    var begin = _getFormattedTime(timespan.begin_date, timespan.begin_time),
      end = _getFormattedTime(timespan.end_date, timespan.end_time);

    if (task.name === "") {
      // show notification, mark field as required
      setNotification({
        message: t("no_empty_designation_allowed", null, "capital"),
        show: true,
      });
      return;
    }
    // validate linked object
    if (task.fk_model !== undefined && task.fk_model != null && task.fk_id == null) {
      setNotification({
        message: t("no_valid_object", null, "capital"),
        show: true,
      });
      return;
    }
    // validate team lead
    if (
      task.team_lead === true &&
      (task.assignee === undefined || task.assignee == null || task.assignee === "")
    ) {
      setNotification({
        message: t("missing_team_lead", null, "capital"),
        show: true,
      });
      return;
    }
    let clone = { ...task };
    if (unsafedComment !== null) {
      if (unsafedComment.comment.length > 0) {
        let tc = {
          user_id: unsafedComment.user_id,
          comment: unsafedComment.comment,
        };
        if (typeof task.id !== "undefined" && task.id !== null) {
          tc.task_id = task.id;
        }
        task.task_comments.push(tc);
        clone.task_comments.push(tc);
      }
    }
    if (typeof clone.id !== "undefined" && clone.id !== null) {
      // is task readonly? -> patch only editable properties
      if (task.readonly) {
        props.dispatch(
          taskActions.editTask({
            id: Number(clone.id),
            body: {
              //name: task.name,
              //client_id: Number(Biscuit.get('user.client_id')),
              //task_category: task.task_category,
              status: clone.status,
              //done: (task.status == 'new'),
              //fk_model: task.fk_model,
              //fk_id: _getSelectedObjectId(task.fk_model),
              assignee: assignedUser == null ? null : assignedUser.id,
              //team_lead: task.team_lead,
              //begin: begin,
              end: end,
              //payment_amount: task.payment_amount,
              //description: task.description,
              task_comments: clone.task_comments,
              all_roles: true,
              images: clone.images,
            },
            token: Biscuit.get("token"),
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          }),
        );
      } else {
        props.dispatch(
          taskActions.editTask({
            id: Number(clone.id),
            body: {
              name: clone.name,
              client_id: Number(Biscuit.get("user.client_id")),
              task_category: clone.task_category,
              status: clone.status,
              done: clone.status === "new",
              fk_model: clone.fk_model,
              fk_id: _getSelectedObjectId(clone.fk_model),
              fk_description: clone.fk_description,
              assignee: assignedUser == null ? null : assignedUser.id,
              team_lead: clone.team_lead,
              begin: begin,
              end: end,
              payment_amount: clone.payment_amount,
              description: clone.description,
              task_comments: clone.task_comments,
              all_roles: true,
              images: clone.images,
            },
            token: Biscuit.get("token"),
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          }),
        );
      }
    } else {
      props.dispatch(
        taskActions.addTask({
          body: {
            name: clone.name,
            client_id: Number(Biscuit.get("user.client_id")),
            task_category: clone.task_category,
            status: clone.status,
            done: clone.status === "new",
            fk_model: clone.fk_model,
            fk_id: _getSelectedObjectId(clone.fk_model),
            fk_description: clone.fk_description,
            assignee: assignedUser == null ? null : assignedUser.id,
            team_lead: clone.team_lead,
            begin: begin,
            end: end,
            payment_amount: clone.payment_amount,
            description: clone.description,
            task_comments: clone.task_comments,
            all_roles: true,
            task_type_id: 67, // Userdefined TaskType
          },
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }
    setItemState("saving");
  };

  const onChangeForm = (e) => {
    var clone = {};
    Object.assign(clone, task);

    switch (e.target.name) {
      case "task_name":
        clone.name = e.target.value;
        break;
      case "task_category":
        clone.task_category = e.target.value;
        break;
      case "status":
        clone.status = e.target.value;
        break;
      case "fk_model":
        clone.fk_model = e.target.value;
        clone.fk_id = ""; // reset object reference because it's invalid after changin object type
        switch (e.target.value) {
          case "Facilities":
            props.dispatch(
              facilityActions.getFacilities({
                token: Biscuit.get("token"),
                filter: {
                  findForSelect: true, // currently ignored and not implemented in backend for facilities but should be useful to reduce payload
                },
              }),
            );
            break;
        }
        break;
      case "fk_id":
        clone.fk_id = e.target.value;
        break;
      case "assignee":
        clone.assignee = e.target.value;
        clone.status = e.target.value === "" ? "new" : "inprogress";
        break;
      case "team_lead":
        clone.team_lead = e.target.checked;
        break;
      case "begin":
        clone.begin = e.target.value;
        break;
      case "end":
        clone.end = e.target.value;
        break;
      case "payment_amount":
        clone.payment_amount = e.target.value;
        break;
      case "description":
        clone.description = e.target.value;
        break;
      case "order_nbr":
        if (!isNaN(Number(e.target.value))) {
          props.dispatch(
            ordersActions.getOrders({
              token: Biscuit.get("token"),
              filter: {
                order_nbr: e.target.value,
              },
            }),
          );
          setOrderStatus({ request: "pending", number: e.target.value });
        } else {
          // show some kind of warning
          console.log("Order-Number must be a number!");
          setOrderStatus({ request: orderStatus.request, number: e.target.value });
        }
        break;
    }
    setTask(clone); // set object state
  };

  const onChangeBeginDate = (value) => {
    // validate selection if validation makes sense
    let begin, end;

    if (timespan.end_time !== "" && timespan.begin_time !== "") {
      // compare time only if both time values are set
      begin = moment(_getFormattedTime(value, timespan.begin_time));
      end = moment(_getFormattedTime(timespan.end_date, timespan.end_time));
      if (begin >= end) {
        // begin must be smaller than end
        setNotification({
          message: "Enddatum darf nicht vor dem Startdatum liegen!",
          show: true,
        });
        return;
      }
    } else if (value !== "" && timespan.end_date !== "") {
      // compare dates only if both dates have been set
      begin = moment(_getFormattedTime(value, ""));
      end = moment(_getFormattedTime(timespan.end_date, ""));
      if (begin > end) {
        // similar dates are accepted, time is just unspecified (like do it somehow during the day)
        setNotification({
          message: "Startzeitpunkt muss vor dem Endzeitpunkt liegen!",
          show: true,
        });
        return;
      }
    }
    // preset begin time with 0:00 if it hasn't been set before or the task is new (then the initial begin date is going to be changed)
    if (
      value !== "" &&
      (timespan.begin_time === "" || task.id === undefined || task.id == null || task.id === "")
    ) {
      setTimespan({
        ...timespan,
        begin_date: value,
        begin_time: "00:00",
      });
    } else {
      setTimespan({
        ...timespan,
        begin_date: value,
      });
    }
  };

  const onChangeEndDate = (value) => {
    // validate selection if validation makes sense
    let begin, end;

    if (timespan.end_time !== "" && timespan.begin_time !== "") {
      // compare time only if both time values are set
      begin = moment(_getFormattedTime(timespan.begin_date, timespan.begin_time));
      end = moment(_getFormattedTime(value, timespan.end_time));
      if (begin >= end) {
        // begin must be smaller than end
        setNotification({
          message: "Enddatum darf nicht vor dem Startdatum liegen!",
          show: true,
        });
        return;
      }
    } else if (value !== "" && timespan.begin_date !== "") {
      // compare dates only if both dates have been set
      begin = moment(_getFormattedTime(timespan.begin_date, ""));
      end = moment(_getFormattedTime(value, ""));
      if (begin > end) {
        // similar dates are accepted, time is just unspecified (like do it somehow during the day)
        setNotification({
          message: "Startzeitpunkt muss vor dem Endzeitpunkt liegen!",
          show: true,
        });
        return;
      }
    }

    if (value !== "" && timespan.end_time === "") {
      setTimespan({
        ...timespan,
        end_date: value,
        end_time: "23:55",
      });
    } else {
      setTimespan({
        ...timespan,
        end_date: value,
      });
    }
  };

  const onChangeBeginTime = (val) => {
    if (timespan.begin_date === "") {
      setNotification({
        message: "Bitte zuerst ein Start-Datum wählen.",
        show: true,
      });
      return false;
    }

    // validate time, compare only if both times are set
    if (timespan.end_time !== "") {
      let begin = moment(_getFormattedTime(timespan.begin_date, val));
      let end = moment(_getFormattedTime(timespan.end_date, timespan.end_time));
      if (begin >= end) {
        setNotification({
          message: "Startzeitpunkt muss vor dem Endzeitpunkt liegen!",
          show: true,
        });
        return false;
      }
    }

    setTimespan({
      ...timespan,
      begin_time: val,
    });

    return true;
  };

  const onChangeEndTime = (val) => {
    if (timespan.end_date === "") {
      setNotification({
        message: "Bitte zuerst ein End-Datum wählen.",
        show: true,
      });
      return false;
    }

    // validate time, compare only if both times are set
    if (timespan.end_time !== "") {
      let begin = moment(_getFormattedTime(timespan.begin_date, timespan.begin_time));
      let end = moment(_getFormattedTime(timespan.end_date, val));
      if (begin >= end) {
        setNotification({
          message: "Startzeitpunkt muss vor dem Endzeitpunkt liegen!",
          show: true,
        });
        return false;
      }
    }

    setTimespan({
      ...timespan,
      end_time: val,
    });

    return true;
  };

  if (
    typeof task.id !== "undefined" &&
    task.id !== "" &&
    typeof task.task_comments === "undefined"
  ) {
    setTask({
      ...task,
      task_comments: [],
    });

    props.dispatch(
      taskActions.getTask({
        id: task.id,
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  }

  const addComment = (content) => {
    // add comment to local task
    let comments = [...task.task_comments];
    comments.push({
      ...content,
      created: moment().format("YYYY-MM-DD HH:mm:ss"),
      task_id: Number(task.id),
    });

    setTask({
      ...task,
      task_comments: comments,
    });

    props.dispatch(
      taskActions.addTaskComment({
        id: Number(task.id),
        body: {
          ...content,
          task_id: Number(task.id),
          all_roles: true,
        },
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  const closeNotification = () => {
    setNotification({
      ...notification,
      show: false,
    });
  };
  const currentUrl = new URL(window.location.href);
  const close = () => {
    props.dispatch(taskActions.resetTask());
    props.dispatch(ordersActions.getOrderResetData());
    props.dispatch(userActions.getUserResetData());
    props.dispatch(resourcesActions.getResourceResetData());
    let requestPath = "";
    if (
      typeof props.requestPath !== "undefined" &&
      !props.requestPath.includes("/tasks/" + task.id)
    ) {
      requestPath = props.requestPath;
    }
    let currentURL = "";
    if (!currentUrl.search.includes("/tasks/" + task.id)) {
      currentURL = currentUrl.search;
    }
    let returnUrl = requestPath !== "" ? requestPath + currentURL : `/tasks${currentURL}`;
    window.location.replace(returnUrl);
    //props.setIndex(null);
    /* props.setResource([]);
         props.setIndex(null);
         //setToggleItemView(false);
         props.setAdd(false);
         alert('set Resource Changed');
         props.setResourcesPending(true);
         props.filterChangedHandle(props.filter);*/
    // props.onClose();
  };
  const abortButtonRef = React.createRef();
  const _exchangeLabel = (value) => {
    let cm = getContentModifications();
    if (cm.labels != null) {
      if (cm.labels[value] !== undefined) {
        return cm.labels[value];
      }
    }
    return value;
  };
  let returnUrl = typeof props.requestPath !== "undefined" ? props.requestPath : "#";
  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"> </div>
      {notification.show && (
        <>
          <Notification message={notification.message} close={closeNotification}></Notification>
        </>
      )}
      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {task !== null && task.id !== undefined && task.id !== ""
              ? t("edit task ${a}", { a: task.task_nbr })
              : t("new_task_name")}
          </h1>
          <div className="off-canvas__actions column">
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("save")}
              onClick={onSubmit}
            >
              {itemState === "init" && (
                <>
                  <i className="fi fi-check"> </i>
                  <span>{t("save")}</span>
                </>
              )}
              {itemState === "saving" && (
                <span>
                  <img
                    alt="RollingLoader"
                    className="rollingLoader"
                    src={"assets/img/rolling_loader.svg"}
                  />
                  {t("save")}
                </span>
              )}
            </button>
            <a href="#">
              <button
                ref={abortButtonRef}
                type="button"
                id="inb-tasksform-abort-button"
                className="button hollow secondary right button-abort round"
                title={t("close_window")}
                onClick={() => close()}
              >
                <i className="fi fi-x"> </i>
              </button>
            </a>
          </div>
        </header>
        <p className="off-canvas__subtitle off-canvas__header-region">
          {typeof task.created !== "undefined" &&
            t("created_at") +
              " " +
              moment(task.created).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              _getUserNameById(
                task.created_by,
                false,
                props.userQueue,
                props.setUserQueue,
                props.extraUsers,
              ) +
              " | " +
              t("last_modified_at") +
              " " +
              moment(task.modified).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              _getUserNameById(
                task.modified_by,
                false,
                props.userQueue,
                props.setUserQueue,
                props.extraUsers,
              )}
        </p>
        <form className="off-content row">
          <div className="inb-form-group column medium-6 small-12 username">
            <label className="inb-form__controlLabel">{t("designation")} *</label>
            <div className="inb-form__controllClass">
              <textarea
                readOnly={task.readonly}
                id="task_item_input_name"
                type="text"
                className="form-control"
                name="task_name"
                required=""
                row="2"
                autoComplete="false"
                maxLength="127"
                placeholder=""
                value={task.readonly ? t(task.name) : task.name}
                onChange={onChangeForm}
                style={{ overflow: "hidden", resize: "vertical", height: "80px" }}
              >
                {" "}
              </textarea>
            </div>
          </div>
          {false && (
            <div className="inb-form-group column medium-3 small-12 lang">
              <label className="inb-form__controlLabel">{t("task_category")} *</label>
              <div className="inb-form__controllClass">
                <select
                  className="form-control "
                  name="task_category"
                  required=""
                  value={task.task_category}
                  onChange={onChangeForm}
                >
                  <option value="todo">{t("task")}</option>
                  <option value="contract">{t("contract")}</option>
                </select>
              </div>
            </div>
          )}
          <div className="inb-form-group column medium-4 small-12 lang">
            <label className="inb-form__controlLabel">Status *</label>
            <div className="inb-form__controllClass">
              <select
                className="form-control "
                name="status"
                value={task.status}
                required=""
                onChange={onChangeForm}
              >
                <option value="new">{t("new")}</option>
                <option value="inprogress">{t("in_progress")}</option>
                <option value="done">{t("done")}</option>
              </select>
            </div>
          </div>

          <div className="inb-form-group column medium-6 small-12 lang">
            <label className="inb-form__controlLabel">{t("begin")}</label>
            <div className="input-group" style={{ maxWidth: "180px" }}>
              <>
                <DatePicker
                  className="noBorders-noBackground"
                  dateFormat="dd.MM.y"
                  selected={timespan.begin_date}
                  onChange={(date) => onChangeBeginDate(date)}
                  onKeyDown={(e) => {
                    if (e.keyCode === 8) e.preventDefault();
                  }}
                  placeholderText=""
                  locale={de}
                  readOnly={task.readonly}
                />
              </>
              <>
                <InboomaTimePicker
                  handleChange={onChangeBeginTime}
                  time={timespan.begin_time}
                  readOnly={task.readonly}
                ></InboomaTimePicker>
              </>
            </div>
          </div>

          <div className="inb-form-group column medium-6 small-12 lang">
            <label className="inb-form__controlLabel">{t("done_until") + " " + t("till")}</label>
            <div className="input-group" style={{ maxWidth: "180px" }}>
              <>
                <DatePicker
                  className="noBorders-noBackground"
                  dateFormat="dd.MM.y"
                  selected={timespan.end_date}
                  onChange={(date) => onChangeEndDate(date)}
                  onKeyDown={(e) => {
                    if (e.keyCode === 8) e.preventDefault();
                  }}
                  placeholderText=""
                  locale={de}
                />
              </>
              <InboomaTimePicker
                handleChange={onChangeEndTime}
                time={timespan.end_time}
              ></InboomaTimePicker>
            </div>
          </div>

          <div className="inb-form-group column medium-4 small-12 lang">
            <label className="inb-form__controlLabel">{t("assigned")}</label>
            <div className="inb-form__controllClass" style={{ height: "36px" }}>
              <div
                className={"inbooma-select-box" + (assigneeState.isOpen ? "" : " close")}
                style={{ zIndex: "0" }}
              >
                {assignedUser == null && (
                  <input
                    className="inbooma-select-box__input"
                    placeholder={t("add_existing_user")}
                    value={assigneeState.value}
                    onClick={() => {
                      setAssigneeState({ ...assigneeState, isOpen: true });
                    }}
                    onBlur={() => {
                      setAssigneeState({ ...assigneeState, isOpen: false });
                    }}
                    onChange={(e) => {
                      queryAssigneeSelectHandle(e);
                    }}
                    style={{ width: "100%" }}
                  />
                )}
                {assignedUser !== undefined && assignedUser != null && (
                  <input
                    className="inbooma-select-box__input"
                    placeholder={t("add_existing_user")}
                    value={assignedUser.first_name + " " + assignedUser.last_name}
                    readOnly
                    style={{
                      background: "#fff",
                      border: "1px solid #e3e3e3",
                      padding: "0.5rem",
                      fontSize: "0.9rem",
                      color: "#3b3b3b",
                    }}
                    onClick={() => {
                      setAssigneeState({ ...assigneeState, isOpen: true });
                    }}
                    onBlur={() => {
                      setAssigneeState({ ...assigneeState, isOpen: false });
                    }}
                    onChange={(e) => {
                      queryAssigneeSelectHandle(e);
                    }}
                    style={{ width: "100%" }}
                  />
                )}
                {assignedUser !== undefined && assignedUser != null && (
                  <a
                    href="#"
                    className="inbooma-select-box__reset"
                    onClick={() => assigneeSelectHandle(null)}
                  >
                    x
                  </a>
                )}
                {_usersResults.success === true && (
                  <ul
                    className={
                      "inbooma-select-box-results" + (assigneeState.isOpen ? "" : " hidden")
                    }
                  >
                    {_usersResults.data.map((user, index) => {
                      return (
                        <li
                          className={
                            "inbooma-select-box-results__field" +
                            (task.assignee === user.id ? " selected" : "")
                          }
                          key={user.id}
                          value={user.id}
                          onClick={() => {
                            assigneeSelectHandle(user);
                          }}
                        >
                          {user.first_name + " " + user.last_name}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            </div>
          </div>

          <div className="inb-form-group column medium-3 small-3 lang">
            <label className="inb-form__controlLabel">&nbsp;</label>
            <div className="inb-form__controllClass" style={{ display: "flex" }}>
              <input
                type="checkbox"
                id="pt1"
                className="form-control"
                name="team_lead"
                autoComplete="false"
                maxLength="255"
                checked={task.team_lead}
                onChange={onChangeForm}
                placeholder=""
                style={{ marginTop: "auto", marginBottom: "auto" }}
              />
              <label htmlFor="radio1"> {t("team_lead")}</label>
              {/*<select className="form-control " name="team_lead" value={task.team_lead} required="" onChange={onChangeForm}>
                            <option></option>
                        </select>*/}
            </div>
          </div>

          <div className="inb-form-group column medium-12 small-12">
            <hr />
          </div>

          <div className="inb-form-group column medium-3 small-12 lang">
            <label className="inb-form__controlLabel">{t("object_type")}</label>
            <div className="inb-form__controllClass">
              <select
                disabled={task.readonly}
                className="form-control "
                name="fk_model"
                value={task.fk_model}
                required=""
                onChange={onChangeForm}
              >
                <option></option>
                <option value="Resources">{_exchangeLabel(t("Fahrzeug"))}</option>
                <option value="Users">{t("user")}</option>
                {props.facilities.length > 0 && (
                  <option value="Facilities">
                    {task.task_type_id === 69 ? t("Schliessbox") : t("facility")}
                  </option>
                )}
                <option value="Orders">{t("order", null, "capital")}</option>
              </select>
            </div>
            <div style={{ minHeight: "0.4rem", minWidth: "0.1rem" }}></div>
          </div>

          <div className="inb-form-group column medium-3 small-12 lang">
            <label className="inb-form__controlLabel">{t("object")}</label>

            <FkModelInput
              facilities={props.facilities}
              task={task}
              userObjectState={userObjectState}
              linkedUser={linkedUser}
              setUserObjectState={setUserObjectState}
              queryUserObjectSelectHandle={queryUserObjectSelectHandle}
              userObjectSelectHandle={userObjectSelectHandle}
              _usersResults={_usersResults}
              resourceObjectState={resourceObjectState}
              resource={resource}
              setResourceObjectState={setResourceObjectState}
              queryResourceObjectSelectHandle={queryResourceObjectSelectHandle}
              resourceObjectSelectHandle={resourceObjectSelectHandle}
              _resourcesResults={_resourcesResults}
              getUserNameById={props.getUserNameById}
              userQueue={props.userQueue}
              setUserQueue={props.setUserQueue}
              extraUsers={props.extraUsers}
              orderStatus={orderStatus}
              onChangeForm={onChangeForm}
            />

            {task.fk_model !== undefined &&
              task.fk_model != null &&
              task.fk_model != "" &&
              task.fk_id != null &&
              task.fk_id != "" &&
              _getSelectedObjectId(task.fk_model) != "" && (
                <div
                  style={
                    task.readonly
                      ? task.fk_model == "Orders"
                        ? {
                            paddingTop: "0px",
                            fontSize: "0.8rem",
                            textDecoration: "underline",
                            fontStyle: "italic",
                          }
                        : {
                            paddingTop: "32px",
                            fontSize: "0.8rem",
                            textDecoration: "underline",
                            fontStyle: "italic",
                          }
                      : task.fk_model == "Facilities"
                        ? {
                            lineHeight: "0.4",
                            fontSize: "0.8rem",
                            textDecoration: "underline",
                            fontStyle: "italic",
                          }
                        : task.fk_model == "Orders"
                          ? {
                              paddingTop: "0px",
                              lineHeight: "0.4",
                              fontSize: "0.8rem",
                              textDecoration: "underline",
                              fontStyle: "italic",
                            }
                          : {
                              paddingTop: "47px",
                              lineHeight: "0.4",
                              fontSize: "0.8rem",
                              textDecoration: "underline",
                              fontStyle: "italic",
                            }
                  }
                >
                  <a
                    href={props.getObjectReference(
                      task.fk_model,
                      _getSelectedObjectId(task.fk_model),
                    )}
                  >
                    {props.getLabelStringOfModel(task.fk_model, task.id, task.fk_description)}
                  </a>
                </div>
              )}
            {warning != "" && (
              <div
                style={{
                  color: "red",
                  fontSize: "0.8rem",
                  lineHeight: "0.4",
                  minHeight: "0.4rem",
                  minWidth: "0.1rem",
                }}
              >
                {warning}
              </div>
            )}
          </div>

          {task.task_category === "contract" && (
            <div className="inb-form-group column medium-3 small-12 lang">
              <label className="inb-form__controlLabel">{t("payment_amount")}</label>
              <div className="inb-form__controllClass">
                <input
                  type="text"
                  className="form-control"
                  name="payment_amount"
                  autoComplete="false"
                  maxLength="255"
                  value={task.payment_amount}
                  onChange={onChangeForm}
                  placeholder=""
                />
              </div>
            </div>
          )}

          <div className="inb-form-group column medium-12 small-12">
            <hr />
          </div>

          <DescriptionAndImages
            descriptionHtml={descriptionHtml}
            splitObject={splitObject}
            task={task}
            onChangeForm={onChangeForm}
            dispatch={props.dispatch}
          />

          {task.id != null && (
            <CommentList
              dispatch={props.dispatch}
              getUserNameById={_getUserNameById} // function to get user name of author
              userQueue={props.userQueue}
              setUserQueue={props.setUserQueue}
              extraUsers={props.extraUsers}
              comments={task.task_comments}
              addComment={addComment} // function to add comment to local (temporary) task
              setUnsafedComment={setUnsafedComment}
            />
          )}
        </form>
      </div>
    </>
  );
};

export default ItemView;
